<template>
  <div :class="['badge', `badge-${variant} badge-${variant}`, {'badge-compact':compact}, {'badge-pill':pill}]">
    <slot />
  </div>
</template>

<script>
export default {
  props: {
    variant: String,
    compact: Boolean,
    pill: Boolean
  }
}
</script>

<style scoped>
.badge {
  border: 1px solid;
}
.badge-primary {
  border-color: var(--color-primary-pill-border);
  background-color: var(--color-primary-pill-bg);
  color: var(--color-primary-pill-text);
}
.badge-success {
  border-color: var(--color-success-pill-border);
  background-color: var(--color-success-pill-bg);
  color: var(--color-success-pill-text);
}
.badge-danger {
  border-color: var(--color-danger-pill-border);
  background-color: var(--color-danger-pill-bg);
  color: var(--color-danger-pill-text);
}
.badge-warning {
  border-color: var(--color-warning-pill-border);
  background-color: var(--color-warning-pill-bg);
  color: var(--color-warning-pill-text);
}
.badge-secondary {
  border-color: var(--color-secondary-pill-border);
  background-color: var(--color-secondary-pill-bg);
  color: var(--color-secondary-pill-text);
}
</style>
